export default {"src":"/_next/static/media/arrow-right.28288c37.svg","height":18,"width":18};